import React from "react";
import { StyledHero } from "./style";

const PageTitle = (props) => {
    const {heading, settings, featureImage, className, ...others} = props;
    return <StyledHero heading={heading} pageTitle={true} className={className} settings={settings} backgroundImage={featureImage.localFile} {...others} />;
}
export default PageTitle